import { Component, model, input } from '@angular/core';

@Component({
  selector: 'vb-lxp-checkbox',
  standalone: true,
  templateUrl: './vb-lxp-checkbox.component.html',
  host: {
    '[style.display]': "'flex'",
  },
})
export class VbLxpCheckboxComponent {
	checked = model<boolean>(false);
	disabled = input<boolean>(false);

	toggle() {
		if (this.disabled()) return;
		this.checked.update((v) => !v);
	}
}
